import { render, staticRenderFns } from "./vendorForm.vue?vue&type=template&id=32abc4ed&"
import script from "./vendorForm.vue?vue&type=script&lang=js&"
export * from "./vendorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports